import useSWRImmutable from "swr/immutable";
import { relativeURL } from "../relativeURL";

const fetcher = (url) => fetch(url).then((res) => res.json());

export function useLocationInfo(location) {
  const { data, error } = useSWRImmutable(
    () => relativeURL(`/api/location/${location.toLowerCase()}`),
    fetcher
  );
  return {
    locationInfo: data,
    isLoading: !error && !data,
    isError: error,
  };
}
